/**
 * @generated SignedSource<<3f9dca94a4884b437cde716b3763ec8a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type User_me$data = {
  readonly profileImage: {
    readonly url: string | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "User_me";
};
export type User_me$key = {
  readonly " $data"?: User_me$data;
  readonly " $fragmentSpreads": FragmentRefs<"User_me">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "User_me",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "File",
      "kind": "LinkedField",
      "name": "profileImage",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "1f02acb4e9a7d0c60c4d6a4406d249d0";

export default node;
